import { LogoutOptions, useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
// import { deleteUser } from "../chat/apis";
import { message, Spin,Modal } from "antd";
import { useState } from "react";
import axios from "axios";

const { confirm } = Modal;


const Profile =() => {
  const { user, isLoading, error, logout } = useAuth0();
  const navigate = useNavigate();
  const [imageError, setImageError] = useState(false);

  if (isLoading) {
    return (
      <div className="w-full flex justify-center items-center p-4">
        <Spin size="large" />
      </div>
    );
  }

  if (error) return <p>Something went wrong</p>;

  const formattedDate = user?.updated_at
    ? new Date(user.updated_at).toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      })
    : "";

    const deleteUser = (): void => {
        confirm({
          title: 'Are you sure you want to delete Account?',
          content: 'This action cannot be undone.',
          okText: 'Yes, Delete',
          cancelText: 'Cancel',
          okType: 'danger',
          onOk: async (): Promise<void> => {
            try {
              const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/delete/`, {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem('accessToken') || ''}`,
                },
              });
      
              if (response.status === 200) {
                message.success('Account deleted successfully');
                localStorage.removeItem('accessToken');
                window.location.href = '/';
              }
            } catch (error) {
              message.error('Failed');
            }
          },
          onCancel: (): void => {
            message.info('Deletion canceled');
          },
        });
      };
      

      const handleDelete = () => {
        deleteUser(); 
      };

  const getInitials = (name: string | undefined) => {
    if (!name) return "U";
    const parts = name.split(" ");
    const initials = parts.map((p) => p.charAt(0).toUpperCase()).join("");
    return initials.slice(0, 2);
  };

  return (
    <div className="py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto bg-white rounded-xl shadow-md overflow-hidden">
        <div className="bg-[#0383BB] p-6 text-center">
          <div className="relative inline-block">
            {!imageError && user?.picture ? (
              <img
                src={user.picture}
                alt="Profile"
                className="h-32 w-32 rounded-full border-4 border-white object-cover"
                onError={() => setImageError(true)}
              />
            ) : (
              <div className="h-32 w-32 rounded-full border-4 border-white bg-gray-300 flex items-center justify-center text-3xl font-bold text-white">
                {getInitials(user?.name)}
              </div>
            )}

            {user?.email_verified && (
              <span className="absolute bottom-1 right-1 bg-green-500 p-1 rounded-full">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-5 w-5 text-white"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fillRule="evenodd"
                    d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                    clipRule="evenodd"
                  />
                </svg>
              </span>
            )}
          </div>

          <h1 className="mt-4 text-2xl font-bold text-white">
            {user?.nickname}
          </h1>
          <p className="text-indigo-100 text-center">{user?.email}</p>
        </div>

        <div className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <h2 className="text-sm font-medium">Full Name</h2>
                <p className="mt-1 text-sm text-gray-900">{user?.name}</p>
              </div>
              <div>
                <h2 className="text-sm font-medium">Email</h2>
                <p className="mt-1 text-sm text-gray-900">{user?.email}</p>
              </div>
              <div>
                <h2 className="text-sm font-medium">Nickname</h2>
                <p className="mt-1 text-sm text-gray-900">{user?.nickname}</p>
              </div>
            </div>
            <div className="space-y-4">
              <div>
                <h2 className="text-sm font-medium">Email Verification</h2>
                <p className="mt-1 text-sm text-gray-900">
                  {user?.email_verified ? "Verified" : "Not Verified"}
                </p>
              </div>
              <div>
                <h2 className="text-sm font-medium">Last Updated</h2>
                <p className="mt-1 text-sm text-gray-900">{formattedDate}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="px-6 pb-6">
          <button
            onClick={handleDelete}
            className="text-sm primary text-white p-2 font-medium"
          >
            Delete Account
          </button>
        </div>
      </div>
    </div>
  );
}
export default Profile;
